<template>
  <v-container class="changelog-container">
    <v-card class="status-overview-card mb-6">
      <v-card-title class="d-flex align-center">
        <v-icon color="primary" size="24" class="mr-2">mdi-update</v-icon>
        Changelogs
        <v-spacer></v-spacer>
        <v-chip color="primary" size="small">Stand: 06. November 2025</v-chip>
      </v-card-title>

      <v-card-text>
        <p class="text-body-2 mb-6">
          Diese Seite dokumentiert die Änderungen und Verbesserungen der
          ARCM-Anwendung.
        </p>

        <!-- Version 2.0.0 -->
        <div class="version-entry mb-6">
          <div class="version-header d-flex align-center">
            <v-chip variant="outlined" color="primary" size="small" class="mr-2"
              >v2.0.0</v-chip
            >
            <span class="version-date">06. November 2025</span>
            <v-spacer></v-spacer>
            <v-chip color="success" size="x-small">Aktuell</v-chip>
          </div>
          <div class="version-title mt-1">
            Sammelaccounts & Session-Management Überarbeitung
          </div>

          <v-row class="mt-3">
            <v-col cols="12" md="4">
              <v-card class="feature-card" color="success-lighten-5">
                <v-card-title class="py-2 px-4 d-flex align-center">
                  <v-icon color="success" class="mr-2">mdi-plus-circle</v-icon>
                  Neue Funktionen
                </v-card-title>

                <v-card-text class="py-2 px-4">
                  <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card class="feature-card" color="info-lighten-5">
                <v-card-title class="py-2 px-4 d-flex align-center">
                  <v-icon color="info" class="mr-2">mdi-cog</v-icon>
                  Verbesserungen
                </v-card-title>

                <v-card-text class="py-2 px-4">
                  <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card class="feature-card" color="warning-lighten-5">
                <v-card-title class="py-2 px-4 d-flex align-center">
                  <v-icon color="warning" class="mr-2">mdi-bug-outline</v-icon>
                  Bugfixes
                </v-card-title>

                <v-card-text class="py-2 px-4">
                  <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row class="mt-3">
            <v-col cols="12" md="6">
              <v-card class="feature-card" color="grey-darken-3" outlined>
                <v-card-title class="py-2 px-4 d-flex align-center">
                  <v-icon color="deep-purple-lighten-2" class="mr-2">mdi-api</v-icon>
                  Backend-Änderungen
                </v-card-title>

                <v-card-text class="py-2 px-4">
                  <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card class="feature-card" color="grey-darken-3" outlined>
                <v-card-title class="py-2 px-4 d-flex align-center">
                  <v-icon color="blue-grey-lighten-2" class="mr-2">mdi-wrench</v-icon>
                  Technische Details
                </v-card-title>

                <v-card-text class="py-2 px-4">
                  <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <div class="d-flex justify-center my-4">
          <v-btn
            variant="outlined"
            color="primary"
            @click="showOlderVersions = !showOlderVersions"
          >
            {{
              showOlderVersions
                ? "Ältere Versionen ausblenden"
                : "Ältere Versionen anzeigen"
            }}
          </v-btn>
        </div>

        <!-- Ältere Versionen -->
        <div v-if="showOlderVersions" class="mt-6">
          <v-divider class="mb-6"></v-divider>

          <!-- Version 1.9.0 -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip variant="outlined" color="grey" size="small" class="mr-2"
                >v1.9.0</v-chip
              >
              <span class="version-date">16. Oktober 2025</span>
            </div>
            <div class="version-title mt-1">
              Barcode-Scanner Integration & Verbesserungen bei Instandsetzung und IRIS-Code Matrix
            </div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row class="mt-3">
                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2">mdi-plus-circle</v-icon>
                          Neue Funktionen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                            <li>Barcode-Scanner für Seriennummern</li>
                            <li>IRIS-Code Matrix mit erweiterten Filteroptionen</li>
                            <li>Verbesserte Instandsetzungs-Übersicht</li>
                          </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Version 1.8.0 -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip variant="outlined" color="primary" size="small" class="mr-2"
                >v1.8.0</v-chip
              >
              <span class="version-date">7. Juli 2025</span>
            </div>
            <div class="version-title mt-1">
              Dynamisches Reinigungsplan-System mit flexibler KC-Verwaltung & PDF-Export
            </div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2">mdi-plus-circle</v-icon>
                          Neue Funktionen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

            <v-col cols="12" md="4">
              <v-card class="feature-card" color="info-lighten-5">
                <v-card-title class="py-2 px-4 d-flex align-center">
                  <v-icon color="info" class="mr-2">mdi-pencil</v-icon>
                  Verbesserungen
                </v-card-title>

                <v-card-text class="py-2 px-4">
                  <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card class="feature-card" color="error-lighten-5">
                <v-card-title class="py-2 px-4 d-flex align-center">
                  <v-icon color="error" class="mr-2">mdi-bug</v-icon>
                  Fehlerbehebungen
                </v-card-title>

                <v-card-text class="py-2 px-4">
                  <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
        </div>

        <!-- Ältere Versionen anzeigen Button -->
        <div class="text-center mt-6">
          <v-btn
            variant="outlined"
            color="primary"
            prepend-icon="mdi-history"
            @click="showOlderVersions = !showOlderVersions"
          >
            {{
              showOlderVersions
                ? "Ältere Versionen ausblenden"
                : "Ältere Versionen anzeigen"
            }}
          </v-btn>
        </div>

        <!-- Ältere Versionen -->
        <div v-if="showOlderVersions" class="mt-6">
          <v-divider class="mb-6"></v-divider>

          <!-- Version 1.8.0 -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip variant="outlined" color="primary" size="small" class="mr-2"
                >v1.8.0</v-chip
              >
              <span class="version-date">7. Juli 2025</span>
            </div>
            <div class="version-title mt-1">
              Dynamisches Reinigungsplan-System mit flexibler KC-Verwaltung & PDF-Export
            </div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2">mdi-plus-circle</v-icon>
                          Neue Funktionen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="info-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-cog</v-icon>
                          Verbesserungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="error-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="error" class="mr-2">mdi-bug</v-icon>
                          Fehlerbehebungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Version 1.7.0 -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip variant="outlined" color="primary" size="small" class="mr-2"
                >v1.7.0</v-chip
              >
              <span class="version-date">6. Juni 2025</span>
            </div>
            <div class="version-title mt-1">
              Erweiterte Statistiken & verbessertes Dashboard
            </div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2">mdi-plus-circle</v-icon>
                          Neue Funktionen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="info-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-pencil</v-icon>
                          Verbesserungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="error-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="error" class="mr-2">mdi-bug</v-icon>
                          Fehlerbehebungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Version 1.6 -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip variant="outlined" color="primary" size="small" class="mr-2"
                >v1.6</v-chip
              >
              <span class="version-date">15. April 2025</span>
            </div>
            <div class="version-title mt-1">
              ReturenSorting-Rolle & optimierte Retourenverwaltung
            </div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2">mdi-plus-circle</v-icon>
                          Neue Funktionen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="info-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-pencil</v-icon>
                          Verbesserungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="error-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="error" class="mr-2">mdi-bug</v-icon>
                          Fehlerbehebungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Version 1.5.12 -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip variant="outlined" color="primary" size="small" class="mr-2"
                >v1.5.12</v-chip
              >
              <span class="version-date">13. April 2025</span>
            </div>
            <div class="version-title mt-1">
              Geburtstage, Notizen-System & Changelog-Integration
            </div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2">mdi-plus-circle</v-icon>
                          Neue Funktionen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="info-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-pencil</v-icon>
                          Verbesserungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="error-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="error" class="mr-2">mdi-bug</v-icon>
                          Fehlerbehebungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Version 1.5.11 -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip variant="outlined" color="primary" size="small" class="mr-2"
                >v1.5.11</v-chip
              >
              <span class="version-date">11. April 2025</span>
            </div>
            <div class="version-title mt-1">
              Technologie-Update mit verbesserter Performance & Reaktionsgeschwindigkeit
            </div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2">mdi-plus-circle</v-icon>
                          Neue Funktionen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="info-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-pencil</v-icon>
                          Verbesserungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="error-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="error" class="mr-2">mdi-bug</v-icon>
                          Fehlerbehebungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Version 1.5.9 -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip variant="outlined" color="primary" size="small" class="mr-2"
                >v1.5.9</v-chip
              >
              <span class="version-date">1. April 2025</span>
            </div>
            <div class="version-title mt-1">
              Individuelle Arbeitszeiterfassung, verbesserte Kalenderzuordnung & moderne Statistik-Widgets
            </div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2">mdi-plus-circle</v-icon>
                          Neue Funktionen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="info-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-pencil</v-icon>
                          Verbesserungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="error-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="error" class="mr-2">mdi-bug</v-icon>
                          Fehlerbehebungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Version 1.5.8 -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip variant="outlined" color="primary" size="small" class="mr-2"
                >v1.5.8</v-chip
              >
              <span class="version-date">25. März 2025</span>
            </div>
            <div class="version-title mt-1">
              Rechte Sidebar-Integration, Stundensatz-Korrektur & Mitarbeiternummern
            </div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2">mdi-plus-circle</v-icon>
                          Neue Funktionen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="info-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-pencil</v-icon>
                          Verbesserungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="error-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="error" class="mr-2">mdi-bug</v-icon>
                          Fehlerbehebungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Version 1.5.7 -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip variant="outlined" color="primary" size="small" class="mr-2"
                >v1.5.7</v-chip
              >
              <span class="version-date">23. März 2025</span>
            </div>
            <div class="version-title mt-1">
              Design-Overhaul, Zeitzonenoptimierung & verbesserte Arbeitszeitberechnung
            </div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2">mdi-plus-circle</v-icon>
                          Neue Funktionen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="info-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-pencil</v-icon>
                          Verbesserungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="error-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="error" class="mr-2">mdi-bug</v-icon>
                          Fehlerbehebungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Version 1.5.6 -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip variant="outlined" color="primary" size="small" class="mr-2"
                >v1.5.6</v-chip
              >
              <span class="version-date">21. März 2025</span>
            </div>
            <div class="version-title mt-1">
              Erweiterte Chat-Funktionen & optimierte Navigation
            </div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2">mdi-plus-circle</v-icon>
                          Neue Funktionen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="info-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-pencil</v-icon>
                          Verbesserungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="error-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="error" class="mr-2">mdi-bug</v-icon>
                          Fehlerbehebungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Version 1.5.5 -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip variant="outlined" color="primary" size="small" class="mr-2"
                >v1.5.5</v-chip
              >
              <span class="version-date">19. März 2025</span>
            </div>
            <div class="version-title mt-1">
              Verbesserte Zeiterfassung & Kalenderintegration
            </div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2">mdi-plus-circle</v-icon>
                          Neue Funktionen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="info-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-pencil</v-icon>
                          Verbesserungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="error-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="error" class="mr-2">mdi-bug</v-icon>
                          Fehlerbehebungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Version 1.5.4 -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip variant="outlined" color="primary" size="small" class="mr-2"
                >v1.5.4</v-chip
              >
              <span class="version-date">17. März 2025</span>
            </div>
            <div class="version-title mt-1">
              Cache-Busting, Update-Benachrichtigungen & neue Benutzerrollen
            </div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2">mdi-plus-circle</v-icon>
                          Neue Funktionen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="info-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-shield-account</v-icon>
                          Berechtigungen & Rollen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="info-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-pencil</v-icon>
                          Verbesserungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Version 1.5.3 -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip variant="outlined" color="primary" size="small" class="mr-2"
                >v1.5.3</v-chip
              >
              <span class="version-date">16. März 2025</span>
            </div>
            <div class="version-title mt-1">
              Zentrale Fehlerbehandlung, verbesserte WebSocket-Sicherheit &
              API-Stabilitätsverbesserungen
            </div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2">mdi-shield-check</v-icon>
                          Sicherheitsverbesserungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="info-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-pencil</v-icon>
                          Verbesserungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="error-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="error" class="mr-2">mdi-bug</v-icon>
                          Fehlerbehebungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Version 1.5.2 -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip
                variant="outlined"
                color="primary"
                size="small"
                class="mr-2"
                >v1.5.2</v-chip
              >
              <span class="version-date">10. März 2025</span>
            </div>
            <div class="version-title mt-1">
              Implementierung User Status mit WebSocket-Integration,
              Designänderungen & diverse Fixes
            </div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2"
                            >mdi-plus-circle</v-icon
                          >
                          Neue Funktionen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="info-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-pencil</v-icon>
                          Verbesserungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="error-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="error" class="mr-2">mdi-bug</v-icon>
                          Fehlerbehebungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Version 1.5.1 -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip
                variant="outlined"
                color="primary"
                size="small"
                class="mr-2"
                >v1.5.1</v-chip
              >
              <span class="version-date">06. März 2025</span>
            </div>
            <div class="version-title mt-1">
              Request & Commissions Fix, neues Announcement
            </div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2"
                            >mdi-plus-circle</v-icon
                          >
                          Neue Funktionen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-card class="feature-card" color="error-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="error" class="mr-2">mdi-bug</v-icon>
                          Fehlerbehebungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Version 1.5.0 und älter -->
          <div class="version-entry mb-6">
            <div class="version-header d-flex align-center">
              <v-chip
                variant="outlined"
                color="primary"
                size="small"
                class="mr-2"
                >v1.5.0</v-chip
              >
              <span class="version-date">03. März 2025</span>
            </div>
            <div class="version-title mt-1">Dashboard 2.0 Release</div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2"
                            >mdi-plus-circle</v-icon
                          >
                          Neue Funktionen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="info-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-pencil</v-icon>
                          Verbesserungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card class="feature-card" color="error-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="error" class="mr-2">mdi-bug</v-icon>
                          Fehlerbehebungen
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Erste Version -->
          <div class="version-entry">
            <div class="version-header d-flex align-center">
              <v-chip
                variant="outlined"
                color="success"
                size="small"
                class="mr-2"
                >v1.0.0</v-chip
              >
              <span class="version-date">01. Juli 2024</span>
            </div>
            <div class="version-title mt-1">Initiales Release</div>

            <v-expansion-panels variant="accordion" class="mt-3">
              <v-expansion-panel>
                <v-expansion-panel-title>
                  Details anzeigen
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row>
                    <v-col cols="12">
                      <v-card class="feature-card" color="success-lighten-5">
                        <v-card-title class="py-2 px-4 d-flex align-center">
                          <v-icon color="success" class="mr-2"
                            >mdi-rocket-launch</v-icon
                          >
                          Veröffentlichung
                        </v-card-title>

                        <v-card-text class="py-2 px-4">
                          <ul class="change-list">
                    <li><strong>Sammelaccounts</strong> - Mehrere Mitarbeiter können sich gleichzeitig mit dem gleichen Account einloggen</li>
                    <li>Session-spezifischer Status für Sammelaccounts (jede Person hat eigenen Status)</li>
                    <li>Admin-Verwaltung für Sammelaccounts mit Session-Übersicht</li>
                    <li><strong>Urlaubsplaner</strong> - Vollständiges Urlaubsverwaltungssystem mit Antrags- und Genehmigungsprozess</li>
                    <li><strong>Message Center</strong> - Internes Nachrichtensystem mit Admin-Broadcasts und KV-Integration</li>
                    <li><strong>KV-Confirmations</strong> - Bestätigungssystem für Kundenvisiten mit WebSocket-Updates</li>
                    <li>Session-Status-Updates in Echtzeit (online/pause/beschäftigt/abwesend)</li>
                    <li>Benutzerdefinierte Status-Nachrichten pro Session</li>
                    <li>Anzeigenamen für Sessions (z.B. "Max - Lager")</li>
                  </ul>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref } from "vue";

// State für die Anzeige älterer Versionen
const showOlderVersions = ref(false);
</script>

<style scoped>
.changelog-container {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 24px;
  padding-bottom: 32px;
}

.status-overview-card {
  background-color: rgba(30, 30, 35, 0.7);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
}

.version-entry {
  background: rgba(30, 30, 40, 0.5);
  border-radius: 12px;
  padding: 16px 20px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.version-entry:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.version-date {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
}

.version-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
  background: linear-gradient(45deg, #ffffff, rgba(255, 255, 255, 0.8));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.feature-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border-radius: 8px;
  height: 100%;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.feature-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.change-list {
  list-style-type: none;
  padding-left: 4px;
  margin: 0;
}

.change-list li {
  position: relative;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.95rem;
  padding-left: 20px;
}

.change-list li:last-child {
  margin-bottom: 0;
}

.change-list li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: rgba(var(--v-theme-primary), 1);
}

:deep(.v-expansion-panel) {
  background: transparent !important;
  border: none !important;
}

:deep(.v-expansion-panel-title) {
  color: rgba(255, 255, 255, 0.7) !important;
  font-size: 0.9rem !important;
}

:deep(.v-expansion-panel-text__wrapper) {
  padding: 0 !important;
}

/* Responsive Anpassungen */
@media (max-width: 600px) {
  .version-title {
    font-size: 1rem;
  }

  .version-entry {
    padding: 12px 16px;
  }

  .change-list li {
    font-size: 0.9rem;
  }
}
</style>
